// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "./AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(r.data.user);
        // Clear hash and route to admin home
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        const status = e?.response?.status;
        const detail = e?.response?.data?.detail || "Erro de autenticação";
        if (status === 403) {
          setError("O seu email não está autorizado a aceder ao painel CIEES.");
        } else {
          setError(detail);
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
      <div className="text-center max-w-md px-6" data-testid="auth-callback">
        {error ? (
          <>
            <div className="overline text-[hsl(var(--destructive))]">Acesso negado</div>
            <h1 className="display-heading text-3xl mt-4 text-[hsl(var(--primary))]">
              Não foi possível entrar
            </h1>
            <p className="mt-4 text-[hsl(var(--muted-foreground))]">{error}</p>
            <a href="/admin/login" className="btn-outline mt-8 inline-flex">
              Voltar ao login
            </a>
          </>
        ) : (
          <>
            <div className="overline">A autenticar</div>
            <h1 className="display-heading text-3xl mt-4">Um momento…</h1>
            <p className="mt-4 text-[hsl(var(--muted-foreground))]">
              A validar a sua sessão com o Google.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
